export type MyGrantTask = {
  id: number;
  grant_opportunity_id: number;
  grant_opportunity_milestone_id: number;
  title: string;
  kind: string;
  due_at: string | null;
  completed_at: string | null;
  milestone: {
    id: number;
    title: string;
    stage: string;
  };
  grant_opportunity: {
    id: number;
    title: string;
    status: string;
  };
};

export async function listMyGrantTasks(
  municipalityId: number,
  options: { includeCompleted?: boolean } = {},
): Promise<MyGrantTask[]> {
  const params = options.includeCompleted ? "?include_completed=true" : "";
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/my_grant_tasks${params}`,
    {
      credentials: "include",
      headers: { Accept: "application/json" },
    },
  );
  if (!response.ok) {
    throw new Error("Failed to load your milestones");
  }
  return response.json();
}
